var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame74(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 335,
    viewBox: "0 0 276 335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_1738)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_i_154_1738)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 276,
    height: 335,
    rx: 12,
    fill: "white",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.1248 188.078C91.3621 187.974 91.6309 187.974 91.8682 188.078L120.428 200.601C120.775 200.753 121 201.102 121 201.487V225.243C121 242.224 108.918 256.894 92.5698 259.805L91.4964 260L90.4232 259.805C74.0825 256.894 62 242.224 62 225.243V201.487C62 201.102 62.2249 200.753 62.5716 200.601L91.1248 188.078ZM92.0906 194.087C91.7111 193.921 91.2814 193.921 90.9016 194.087L68.4469 203.932C67.8919 204.175 67.5322 204.733 67.5322 205.351V225.309C67.5322 239.549 77.5869 251.901 91.2142 254.554C91.4004 254.59 91.5919 254.59 91.7782 254.554C105.413 251.901 115.468 239.549 115.468 225.309V205.351C115.468 204.733 115.108 204.175 114.553 203.932L92.0906 194.087ZM91.4964 197.186L112.45 206.368V225.309C112.45 237.974 103.574 248.973 91.4964 251.465C79.4254 248.973 70.5505 237.974 70.5505 225.309V206.368L91.4964 197.186ZM88.3996 226.256L83.9518 221.707C82.7995 220.528 80.9289 220.528 79.7769 221.707C78.6248 222.891 78.6248 224.799 79.7769 225.977L86.3153 232.671C87.4674 233.849 89.3379 233.849 90.49 232.671C94.4332 228.637 99.3059 223.552 103.231 219.5C104.377 218.316 104.372 216.408 103.22 215.236C102.067 214.064 100.197 214.07 99.0505 215.248L88.3996 226.256Z",
    fill: "url(#paint0_linear_154_1738)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8152 174.666C54.8152 173.98 54.3684 173.378 53.7138 173.175L51.7786 172.583C50.0018 172.035 48.7731 170.806 48.225 169.029L47.6327 167.094C47.4301 166.439 46.8274 165.993 46.1416 165.993C45.4585 165.993 44.8532 166.439 44.6532 167.094L44.0583 169.029C43.5128 170.806 42.2815 172.035 40.5047 172.583L38.5695 173.175C37.9175 173.378 37.4707 173.98 37.4707 174.666C37.4707 175.349 37.9175 175.955 38.5695 176.155L40.5073 176.749C42.2841 177.295 43.5154 178.524 44.0609 180.303L44.6558 182.238C44.8558 182.89 45.4611 183.337 46.1442 183.337C46.83 183.337 47.4327 182.89 47.6353 182.236L48.2276 180.303C48.7757 178.524 50.0044 177.295 51.7812 176.749L53.7164 176.155C54.3684 175.955 54.8152 175.349 54.8152 174.666ZM46.1416 171.952C46.8222 173.069 47.7392 173.986 48.8562 174.666C47.7392 175.344 46.8222 176.264 46.1416 177.381C45.4637 176.264 44.5441 175.344 43.4271 174.666C44.5441 173.986 45.4637 173.069 46.1416 171.952ZM125.913 193.359C127.9 194.362 129.456 195.918 130.462 197.907C131.464 195.918 133.02 194.362 135.01 193.359C133.02 192.356 131.464 190.798 130.462 188.81C129.454 190.798 127.898 192.356 125.913 193.359ZM47.2638 231.131C45.274 230.129 43.718 228.573 42.7153 226.583C41.7126 228.573 40.154 230.129 38.1668 231.131C40.1566 232.134 41.7126 233.69 42.7153 235.68C43.718 233.69 45.274 232.134 47.2638 231.131ZM146.292 240.805L146.887 242.738C147.087 243.392 147.692 243.839 148.375 243.839C149.061 243.839 149.666 243.392 149.866 242.738L150.461 240.805C151.006 239.026 152.235 237.797 154.015 237.251L155.947 236.657C156.602 236.457 157.049 235.851 157.049 235.168C157.049 234.482 156.602 233.877 155.947 233.677L154.015 233.082C152.235 232.537 151.006 231.308 150.461 229.529L149.866 227.596C149.666 226.941 149.061 226.495 148.375 226.495C147.692 226.495 147.087 226.941 146.887 227.596L146.292 229.529C145.746 231.308 144.517 232.537 142.738 233.082L140.805 233.677C140.151 233.877 139.704 234.482 139.704 235.168C139.704 235.851 140.151 236.457 140.805 236.657L142.738 237.251C144.517 237.797 145.746 239.026 146.292 240.805ZM148.378 237.88C147.7 236.766 146.78 235.846 145.666 235.168C146.78 234.488 147.7 233.571 148.378 232.454C149.058 233.571 149.978 234.488 151.09 235.168C149.975 235.846 149.056 236.766 148.378 237.88ZM139.621 258.534C138.823 258.207 138.444 257.298 138.771 256.5C139.099 255.705 140.011 255.323 140.805 255.651C150.173 259.503 155.124 264.348 155.124 269.66C155.124 275.723 148.502 281.266 136.483 285.269C124.994 289.093 109.75 291.2 93.5619 291.2C77.3707 291.2 62.1276 289.093 50.6408 285.269C38.6188 281.266 32 275.723 32 269.66C32 264.348 36.9511 259.503 46.3157 255.651C47.1132 255.323 48.0223 255.705 48.3497 256.5C48.677 257.298 48.2977 258.207 47.5002 258.534C39.515 261.817 35.1172 265.769 35.1172 269.66C35.1172 274.206 41.1334 278.817 51.6253 282.31C62.803 286.033 77.6954 288.082 93.5619 288.082C109.426 288.082 124.318 286.033 135.498 282.31C145.988 278.817 152.007 274.206 152.007 269.66C152.007 265.771 147.609 261.817 139.621 258.534ZM135.249 269.66C135.249 273.229 130.898 276.128 122.315 278.274C114.616 280.201 104.404 281.264 93.5619 281.264C82.7192 281.264 72.5079 280.201 64.8058 278.274C56.2257 276.128 51.8747 273.229 51.8747 269.66C51.8747 265.945 56.5686 262.963 65.8267 260.799C66.6657 260.604 67.5048 261.124 67.6996 261.963C67.897 262.799 67.3749 263.638 66.5358 263.836C57.4233 265.966 54.9919 268.499 54.9919 269.66C54.9919 270.753 57.2181 273.161 65.5643 275.25C73.0222 277.118 82.966 278.146 93.5619 278.146C104.155 278.146 114.099 277.118 121.559 275.25C129.906 273.161 132.132 270.753 132.132 269.66C132.132 268.499 129.7 265.966 120.585 263.836C119.746 263.638 119.227 262.799 119.422 261.963C119.619 261.124 120.458 260.604 121.294 260.799C130.558 262.963 135.249 265.945 135.249 269.66Z",
    fill: "url(#paint1_linear_154_1738)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_154_1738",
    x: 0,
    y: 0,
    width: 276,
    height: 338.599,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.59943
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.4964
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_154_1738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_154_1738",
    x1: 91.5,
    y1: 188,
    x2: 91.5,
    y2: 260,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#386641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_154_1738",
    x1: 94.5243,
    y1: 165.993,
    x2: 94.5243,
    y2: 291.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#386641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_1738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 276,
    height: 335,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame74);
export default __webpack_public_path__ + "static/media/Frame 74.1a322bbf1e9ea731b184d44e992dbb4e.svg";
export { ForwardRef as ReactComponent };